import { compose } from 'redux'
import { reduxForm } from 'redux-form'
import withCatalogs from 'src/features/catalogs/withCatalogs'
import RegisterForm from '.'
import validate from './validate'
import { audienceTypes } from 'src/services/FW5ML/parsers/UserParser'

export default compose(
  reduxForm({
    form: 'register',
    initialValues: {
      license: audienceTypes.FREE
    },
    validate,
    touchOnBlur: false
  }),
  withCatalogs({
    jobFunctions: 'jobFunction',
    country: 'country',
    heardAbout: 'heardAboutOptions'
  })
)(RegisterForm)
